import React, { useState, useEffect } from 'react';

const API_URL = 'https://nethajiprime-backend.onrender.com';

function Badges({ user }) {
  const [badges, setBadges] = useState([]);
  const [stats, setStats] = useState({});
  const [newBadges, setNewBadges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewBadge, setShowNewBadge] = useState(false);

  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchBadges();
  }, []);

  const fetchBadges = async () => {
    try {
      const response = await fetch(`${API_URL}/badges/my`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setBadges(data.badges || []);
      setStats(data.stats || {});
      if (data.new_badges && data.new_badges.length > 0) {
        setNewBadges(data.new_badges);
        setShowNewBadge(true);
        setTimeout(() => setShowNewBadge(false), 5000);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  const earnedBadges = badges.filter(b => b.earned);
  const unearnedBadges = badges.filter(b => !b.earned);

  return (
    <div>
      {/* New Badge Popup */}
      {showNewBadge && newBadges.map((badge, i) => (
        <div key={badge.id} style={{
          position: 'fixed', top: '80px', right: '20px', zIndex: 9999,
          background: 'linear-gradient(135deg, #1a2633, #0a1628)',
          border: '2px solid #ffa500', borderRadius: '12px',
          padding: '20px 24px', boxShadow: '0 8px 32px rgba(255,165,0,0.4)',
          animation: 'slideIn 0.5s ease', textAlign: 'center', minWidth: '200px'
        }}>
          <div style={{ fontSize: '3em', marginBottom: '8px' }}>{badge.emoji}</div>
          <div style={{ color: '#ffa500', fontWeight: '800', fontSize: '14px', marginBottom: '4px' }}>🎉 New Badge Earned!</div>
          <div style={{ color: '#fff', fontWeight: '700', fontSize: '16px' }}>{badge.name}</div>
          <div style={{ color: '#aaa', fontSize: '12px', marginTop: '4px' }}>{badge.description}</div>
        </div>
      ))}

      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px', color: '#aaa' }}>Loading badges...</div>
      ) : (
        <>
          {/* Stats summary */}
          <div style={{ background: '#1a2633', borderRadius: '8px', padding: '20px', marginBottom: '24px', border: '1px solid #243447' }}>
            <h3 style={{ color: '#00a8e1', marginBottom: '16px' }}>📊 Your Activity</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '12px' }}>
              {[
                { label: '❤️ Likes', value: stats.likes || 0, color: '#ff6b6b' },
                { label: '🔥 Hypes', value: stats.hypes || 0, color: '#ff6b35' },
                { label: '💬 Comments', value: stats.comments || 0, color: '#a78bfa' },
                { label: '🔔 Following', value: stats.subscriptions || 0, color: '#00a8e1' },
              ].map((stat, i) => (
                <div key={i} style={{ textAlign: 'center', background: '#0f171e', borderRadius: '6px', padding: '12px', border: '1px solid #243447' }}>
                  <div style={{ fontSize: '1.6em', fontWeight: '800', color: stat.color }}>{stat.value}</div>
                  <div style={{ color: '#aaa', fontSize: '12px', marginTop: '4px' }}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Earned Badges */}
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ color: '#fff', marginBottom: '16px', fontSize: '16px' }}>
              🏅 Earned Badges <span style={{ color: '#ffa500', fontWeight: '800' }}>({earnedBadges.length}/{badges.length})</span>
            </h3>
            {earnedBadges.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '30px', background: '#1a2633', borderRadius: '8px', color: '#aaa', border: '1px solid #243447' }}>
                <p style={{ fontSize: '2em', marginBottom: '8px' }}>🏅</p>
                <p>No badges yet! Start watching, liking and commenting to earn badges.</p>
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '14px' }}>
                {earnedBadges.map(badge => (
                  <div key={badge.id} style={{
                    background: 'linear-gradient(135deg, #1a2633, #0f171e)',
                    borderRadius: '12px', padding: '20px', textAlign: 'center',
                    border: '2px solid #ffa500',
                    boxShadow: '0 4px 20px rgba(255,165,0,0.2)'
                  }}>
                    <div style={{ fontSize: '2.5em', marginBottom: '10px' }}>{badge.emoji}</div>
                    <div style={{ color: '#ffa500', fontWeight: '700', fontSize: '14px', marginBottom: '6px' }}>{badge.name}</div>
                    <div style={{ color: '#aaa', fontSize: '11px', lineHeight: '1.4' }}>{badge.description}</div>
                    {badge.earned_at && (
                      <div style={{ color: '#555', fontSize: '10px', marginTop: '8px' }}>
                        {new Date(badge.earned_at).toLocaleDateString()}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Locked Badges */}
          {unearnedBadges.length > 0 && (
            <div>
              <h3 style={{ color: '#aaa', marginBottom: '16px', fontSize: '16px' }}>🔒 Locked Badges</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '14px' }}>
                {unearnedBadges.map(badge => (
                  <div key={badge.id} style={{
                    background: '#1a2633', borderRadius: '12px', padding: '20px',
                    textAlign: 'center', border: '1px solid #243447', opacity: 0.6
                  }}>
                    <div style={{ fontSize: '2.5em', marginBottom: '10px', filter: 'grayscale(100%)' }}>{badge.emoji}</div>
                    <div style={{ color: '#aaa', fontWeight: '700', fontSize: '14px', marginBottom: '6px' }}>{badge.name}</div>
                    <div style={{ color: '#666', fontSize: '11px', lineHeight: '1.4', marginBottom: '10px' }}>{badge.description}</div>
                    {/* Progress bar */}
                    {badge.threshold > 0 && (
                      <div>
                        <div style={{ background: '#243447', borderRadius: '4px', height: '4px', overflow: 'hidden' }}>
                          <div style={{ width: `${badge.progress}%`, height: '100%', background: '#00a8e1', borderRadius: '4px' }}></div>
                        </div>
                        <div style={{ color: '#555', fontSize: '10px', marginTop: '4px' }}>{badge.progress}%</div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Badges;